<ng-template let-f #field>
    <div [formGroup]="form">
        @switch (getInputType(f)) {
            @case ('select') {
                <div class="field mr-2"
                     [ngClass]="getStringWithoutSpecialCharacter(f.label)"
                     [class.is-hidden]="f.hidden || !isVisible(f)">

                    <label class="label is-small">
                        {{ f.label }}
                        @if (isRequired(f)) {
                            <span>*</span>
                        }
                    </label>

                    <div class="select is-small">
                        <select [formControlName]="getStringWithoutSpecialCharacter(f.label)">
                            <option [value]="''">Bitte auswählen</option>
                            @for (s of f.select.options; track s) {
                                <option [value]="s">{{ s }}</option>
                            }
                        </select>
                        @if (isFormRequestError(getStringWithoutSpecialCharacter(f.label))) {
                            <p class="help is-danger">Bitte füllen Sie das Feld aus.</p>
                        }
                    </div>
                </div>
            }
            @case ('textarea') {
                <div class="field mr-2" [ngClass]="getStringWithoutSpecialCharacter(f.label)">
                    <label class="label is-small">{{ f.label }}@if (isRequired(f)) {
                        <span>*</span>
                    }</label>
                    <div class="control">
                    <textarea class="textarea" [placeholder]="f.label"
                              [formControlName]="getStringWithoutSpecialCharacter(f.label)"></textarea>
                        @if (isFormRequestError(getStringWithoutSpecialCharacter(f.label))) {
                            <p class="help is-danger">Bitte füllen Sie das Feld aus.</p>
                        }
                    </div>
                </div>
            }
            @default {
                <div class="field mr-2" [class.is-hidden]="f.hidden || !isVisible(f)">
                    <label class="label is-small">{{ f.label }}@if (isRequired(f)) {
                        <span>*</span>
                    }</label>
                    <div class="control">
                        <input class="input is-small" type="email" [placeholder]="f.label"
                               [formControlName]="getStringWithoutSpecialCharacter(f.label)">
                        @if (isFormRequestError(getStringWithoutSpecialCharacter(f.label))) {
                            <p class="help is-danger">Bitte füllen Sie das Feld aus.</p>
                        }
                    </div>
                </div>
            }
        }
    </div>
</ng-template>
<div class="container-contact-dynamic">

    @if (formStatus == 'success') {
        <div>
            <h1 class="title">Vielen Dank.</h1>
            <p class="subtitle">Die Anfrage wurde erfolgreich abgesendet. </p>
        </div>
    }
    @if (formStatus != 'success') {
        @if (apiError) {
            <div>
                <article class="message is-danger">
                    <div class="message-body">
                        <b>{{ apiError.notification }}</b>
                        @for (error of apiError.errors; track $index) {
                            <span class="is-block">
                                        @if (error.key !== 'email') {
                                            <span>{{ error.key }}:</span>
                                        }
                                {{ error.error }}
                                      </span>
                        }
                    </div>
                </article>
            </div>
        }
        @if(headline){
            <h2 class="subtitle has-text-weight-bold has-color-green is-size-6-mobile">{{headline}}</h2>
        }

        @for (f of fields; track f) {
            @if (f.headline) {
                <div class="mb-0 columns is-gapless">
                    <div class="column is-paddingless headline is-size-4" [innerHTML]="f.headline"></div>
                </div>
            }

            @if (f.field) {
                <div class="columns mt-1" [class.is-hidden]="f.field.hidden || !isVisible(f.field)">
                    <div class="column is-paddingless">
                        <ng-container
                                [ngTemplateOutlet]="field"
                                [ngTemplateOutletContext]="{$implicit: f.field}">
                        </ng-container>
                    </div>
                </div>
            }

            @if (f.fieldsInRow) {
                <div class="columns mt-1">
                    @for (f2 of f.fieldsInRow; track f2) {
                        <div class="column is-paddingless" [class.is-hidden]="f2.hidden || !isVisible(f2)">
                            <ng-container
                                    [ngTemplateOutlet]="field"
                                    [ngTemplateOutletContext]="{$implicit: f2}">
                            </ng-container>
                        </div>
                    }
                </div>
            }
        }
        <div class="columns is-gapless">
            <div class="column">
                <iw-shop-captcha-without-captcha (isVerified)="setCaptcha($event)"></iw-shop-captcha-without-captcha>
                @if (formStatus == 'submitForm' && !captcha) {
                    <article class="message is-danger">
                        <div class="message-body">
                            Bitte bestätigen Sie, dass Sie kein Roboter sind.
                        </div>
                    </article>
                }
            </div>

        </div>
        @if (require_terms_acceptance) {
            <div class="columns is-gapless" [formGroup]="form">
                <div class="column is-paddingless">
                    <label class="checkbox">
                        <input type="checkbox" formControlName="terms">
                        Ich habe die <a href="/datenschutzerklaerung" target="_blank" rel="nofollow">Datenschutzerklärung</a>
                        zur
                        Kenntnis genommen und die <a
                            href="/agb" target="_blank" rel="nofollow">AGB</a> gelesen und bin mit ihnen einverstanden.
                        @if (isFormRequestError('terms')) {
                            <article class="message is-danger">
                                <div class="message-body">
                                    Bitte bestätigen Sie, dass Sie die <a routerLink="/datenschutzerklaerung">Datenschutzerklärung</a>
                                    und
                                    <a routerLink="/agb">AGB</a> zur Kenntnis genommen haben.
                                </div>
                            </article>
                        }
                    </label>
                </div>
            </div>
        }

        <div class="columns is-gapless">

            <div class="column is-paddingless">
                <iw-shop-forms-submit-button [formStatus]="formStatus" [submitLabel]="submit_label"
                                             (submit)="submit()"></iw-shop-forms-submit-button>
                <p class="is-block has-text-right">* Erforderlich.</p>
            </div>

        </div>
    }
</div>

